const en = {
  lead: "Families, hikers, skiers and tourists follow the trolls on foot, on skis and by boat. Put trolls at your door and the hunt leads new guests straight to you — whatever kind of place you run.",
  areasKicker: "Business areas",
  areasTitle: "Find your area.",
  bannerKicker: "Have a business in this area?",
  bannerTitle: "Get more clients. Attract new visitors.",
  cta: "Partner with Trollfossjakten",
  placesLike: "Places like",
  ideaTitle: "Troll idea",
  cats: {
    hotels: {
      name: "Hotels & hotel chains",
      short: "Turn troll hunters into overnight guests.",
      lead: "A troll by your entrance, in the garden or on the hotel's own trail gives families a reason to stay the night — and to come back next season.",
      idea: "A porter troll carrying bags at the door, a breakfast troll by the buffet window and a night troll under the northern lights on the roof terrace.",
      types: ["Hotel chains", "Historic hotels", "Fjord and mountain hotels", "Resorts and spa hotels", "Coastal hotels", "Cabins and lodges"],
    },
    restaurants: {
      name: "Restaurants & café chains",
      short: "Hungry hunters, right at your door.",
      lead: "Hunting trolls makes people hungry. Place trolls at your restaurants and let players pre-order and pay with Vipps on the way.",
      idea: "A chef troll stirring the soup, a pizza troll on the terrace and a coffee troll guarding the best window seat.",
      types: ["Pizza and burger chains", "Coffee chains", "Steakhouses", "Family restaurants", "Sushi and Asian food", "Bakery chains"],
    },
    activities: {
      name: "Activities & experiences",
      short: "Give adventurers one more reason to book.",
      lead: "Fjord trips, rafting, safaris and guided hikes are perfect troll territory. Your trolls turn a tour into a quest — and lead players to your booking desk.",
      idea: "A life-vest troll at the kayak dock, a glacier troll on the ice and an aurora troll that only shows up on winter safaris.",
      types: ["Fjord tours and cruises", "Coastal voyages", "Rafting and kayaking", "Arctic and aurora safaris", "Adventure travel", "Wilderness centres"],
    },
    ski: {
      name: "Ski resorts & mountain destinations",
      short: "Trolls on the slopes, all winter long.",
      lead: "Trolls by the lifts, on the cross-country tracks and at the summit café make every ski day a hunt — and bring families back in summer too.",
      idea: "A ski troll on old wooden skis by the lift, a snow troll on the forest track and a summit troll serving hot cocoa.",
      types: ["Alpine resorts", "Cross-country centres", "Mountain villages", "Summer skiing", "Après-ski and lodges", "Ski schools"],
    },
    attractions: {
      name: "Attractions & museums",
      short: "Let the trolls tell your story.",
      lead: "Trolls belong in Norwegian folklore. Put them in your museum park, by the stave church or along the famous hike, and visitors stay longer and explore more.",
      idea: "A storyteller troll at the old farmhouse, a dragon-head troll on the stave church and a cliff troll guarding the viewpoint.",
      types: ["Open-air museums", "Ship and history museums", "Art museums", "Stave churches and cathedrals", "National parks", "Famous hikes and viewpoints"],
    },
    transport: {
      name: "Transport & ferries",
      short: "Make the journey part of the hunt.",
      lead: "Ferries, express boats, buses and trains carry thousands of curious travellers. Trolls on board and at the quay turn waiting time into play time.",
      idea: "A sea troll waving at the ferry's bow, a ticket troll at the bus stop and a tunnel troll you only meet on the train.",
      types: ["Ferry operators", "Express boats", "Regional buses", "Trains", "City transit", "Quays and terminals"],
    },
    cafes: {
      name: "Cafés & bakeries",
      short: "Fresh buns, warm coffee — and a troll at the door.",
      lead: "A single troll outside your café brings players in for coffee, waffles and cinnamon buns. They can pre-order with Vipps and pick up when they arrive.",
      idea: "A baker troll with flour on its nose, sniffing the cinnamon buns through the window.",
      types: ["Local cafés", "Bakeries", "Coffee roasteries", "Bakery and coffee branches", "Ice-cream kiosks", "Waffle huts"],
    },
    saunas: {
      name: "Saunas",
      short: "Warm up after the hunt.",
      lead: "After a cold day on the trail, nothing beats a sauna by the fjord. A sauna troll leads players to your door, and they can book their slot with Vipps.",
      idea: "A jolly troll in a striped towel, steaming on the deck and daring everyone to jump into the fjord.",
      types: ["Local saunas", "Floating saunas", "Fjord saunas", "Sauna clubs", "Spas and bathhouses", "Hot tubs"],
    },
    shops: {
      name: "Small shops & local producers",
      short: "Small shop, big discovery.",
      lead: "Troll hunters love to bring something home. One troll at your shop puts you on the map for everyone passing by.",
      idea: "A shopkeeper troll with a basket full of jam, cheese and wool socks.",
      types: ["Farm shops", "Souvenir and craft shops", "Breweries and distilleries", "Fishing and outdoor shops", "Bookshops and gift shops", "Grocery, sports and hardware stores"],
    },
  },
};

export default en;
